<template>
  <div
    class="pagination-bubble"
    :class="{ small, }"
  >
    <button
      class="nav-button"
      :disabled="disabled"
      @click="changeByArrow(value - 1)"
    >
      <UilAngleLeftB :size="!small ? '12' : '9'" />
    </button>
    <button
      v-for="(item, index) in length"
      :key="index"
      class="nav-button"
      :disabled="disabled"
      @click="changeByBubble(index)"
    >
      <span
        class="circle"
        :class="{ active: index === value, }"
      />
    </button>
    <button
      class="nav-button"
      :disabled="disabled"
      @click="changeByArrow(value + 1)"
    >
      <UilAngleRightB :size="!small ? '12' : '9'" />
    </button>
  </div>
</template>

<script>
import { UilAngleLeftB, UilAngleRightB } from "@iconscout/vue-unicons";

/**
 * Affiche la pagination sous forme de cercles.
 */
export default {
  name: "PaginationBubble",
  components: {
    UilAngleLeftB,
    UilAngleRightB,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    /**
     * Index de la diapositive courante.
     */
    value: {
      type: Number,
      default: 0,
    },
    /**
     * Réduit la taille du composant.
     */
    small: {
      type: Boolean,
      default: false,
    },
    /**
     * Nombre de cercles.
     */
    length: {
      type: Number,
      default: 3,
    },
    /**
     * Rend le clic sur la pagination impossible.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * Déclenché lors d'un changement de diapositive.
     * @param {Number} - Index de la page
     * @param {Boolean} - Définit si l'animation doit boucler.
     */
    "change",
  ],
  methods: {
    /**
     * Affiche la diapositive précédente ou suivante selon à la flèche cliquée.
     * @param {Number} index Index de la page souhaitée.
     */
    changeByArrow(index) {
      let page = index;
      if (index === -1) {
        page = this.length - 1;
      }
      if (index === this.length) {
        page = 0;
      }
      this.$emit("change", page, true);
    },
    /**
     * Affiche la diapositive relative au cercle cliqué.
     * @param {Number} index  Index de la diapositive souhaitée..
     */
    changeByBubble(index) {
      this.$emit("change", index);
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/nav/pagination_bubble.scss";
</style>
